import { Component, OnInit } from '@angular/core';

import { Certification } from './../../../shared/models/products/certification';
import { Exam } from './../../../shared/models/products/exam';
import { CredentialVerification } from './../../../shared/models/products/credential-verification';
import { IProduct } from './../../../shared/models/products/product';
import { OtherProduct } from './../../../shared/models/products/other-product';

import { PurchaseStateService } from './../../../shared/services/purchase-state.service';
import { AuthService } from './../../../../auth/auth.service';
import { IPurchase } from '../../../shared/models/purchase';

@Component({
  selector: 'app-paynow-confirmation',
  templateUrl: './paynow-confirmation.component.html'
})
export class PayNowConfirmationComponent implements OnInit {
  isExamPurchase: boolean;
  examInfo = {
    isExamPurchase: false,
    schedulingLink: '',
    eligibilityEndDate: ''
  };
  ccpInfo = {
    isCcpPurchase: false,
    isAuditRequired: false,
    isAEC: false,
    requiredByDate: new Date()
  };  
  purchase: IPurchase;

  constructor(private purchaseState: PurchaseStateService,
              private authService: AuthService) {
  }

  ngOnInit() {
    this.purchase = this.purchaseState.getCompletedPurchase();      
    //this.getExamInfo();
    //this.getCcpInfo();
    //this.authService.refreshToken().subscribe();
  }

  // private getExamInfo() {
  //   let exam = <Exam>this.purchase.products.find(p => p.constructor === Exam);
  //   if (!exam) return;

  //   this.examInfo.isExamPurchase = true;
  //   this.examInfo.schedulingLink = exam.schedulingLink,
  //   this.examInfo.eligibilityEndDate = exam.eligibilityEndDate;
  // }

  // private getCcpInfo() {
  //   let certification = <Certification>this.purchase.products.find(p => p.constructor === Certification);
  //   if (!certification) return;    
  //   this.ccpInfo.isCcpPurchase = true;
  //   this.ccpInfo.isAuditRequired = certification.isAuditRequired;
  //   this.ccpInfo.isAEC = certification.isAEC;
  //   this.ccpInfo.requiredByDate = this.calcCcpAuditDate();
  // }

  // private calcCcpAuditDate() {
  //   let dat = new Date();
  //   dat.setDate(dat.getDate() + 14);
  //   return dat;
  // }

  get paymentMethodLabel(): string {
    if (this.purchase.paymentMethod === 'V') {
      return 'Voucher';
    }
    if (this.purchase.paymentMethod === 'CP') {
      return 'No Payment Required';
    }
    if (this.purchase.paymentMethod === 'CH') {
       return 'Check';
    }
    if (this.purchase.paymentMethod === 'CC') {
      return 'Credit Card';
    }
    if (this.purchase.paymentMethod === 'ACH') {
      return 'E-Check'
    }
    return this.purchase.paymentMethod;
  }

  isNoMoneyDue(): boolean {
    if (this.purchase.total ==0)
      return true;
    else
      return false;
  }
}
